// extracted by mini-css-extract-plugin
module.exports = {"EditForm":"EditCorporateProfile_EditForm__3-9Gd","ChangePass":"EditCorporateProfile_ChangePass__E3kD-","UpdatedSuccessfully":"EditCorporateProfile_UpdatedSuccessfully__9IviS"};